import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/feature/PageMeta";
import Hero from "./components/Hero";
import FeaturedTopics from "./components/FeaturedTopics";
import CategoryGrid from "./components/CategoryGrid";
import LatestArchive from "./components/LatestArchive";
import MethodSection from "./components/MethodSection";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";
import { faqs } from "@/mocks/topics";

const origin = typeof window !== "undefined" ? window.location.origin : "";
const prefix = (__BASE_PATH__ || "/").replace(/\/$/, "");
const siteUrl = `${origin}${prefix}`;

export default function Home() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: { "@type": "Answer", text: faq.a },
    })),
  };

  return (
    <SiteLayout>
      <PageMeta
        title="黑料吃话 · 娱乐话题文字版实录与观察平台"
        description="黑料吃话整理娱乐与网络热点的完整文字版：事件时间线、双方对话实录、各方回应与舆论观察笔记，提供可检索、可引用的档案，帮你看透事件全貌。"
        keywords="黑料吃话,黑料吃话文字版,黑料吃话全文,黑料吃话记录整理,话题时间线"
        path="/"
        type="website"
        image="https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20cover%20artwork%20with%20layered%20cream%20paper%20textures%20and%20soft%20vermillion%20accents%2C%20minimal%20sophisticated%20magazine%20mood%2C%20calm%20composition&width=1200&height=630&seq=hc-og-home&orientation=landscape"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "黑料吃话",
            url: `${siteUrl}/`,
            description: "娱乐与网络热点的文字实录与观察平台，提供时间线、对话记录与舆论观察笔记。",
            potentialAction: {
              "@type": "SearchAction",
              target: `${siteUrl}/topics?q={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "黑料吃话",
            url: `${siteUrl}/`,
            description: "专注于娱乐与网络热点文字整理的内容平台。",
            email: "editor@heiliaochihua.cn",
          },
          faqSchema,
        ]}
      />
      <Hero />
      <FeaturedTopics />
      <CategoryGrid />
      <LatestArchive />
      <MethodSection />
      <FaqSection />
      <BrandSection />
    </SiteLayout>
  );
}